class ProductImages extends HTMLElement {
  constructor() {
    super();

    this.images = this.querySelectorAll(".product-image");
    this.thumbs = this.querySelectorAll(".image-thumbnail");

    this.onThumbClick = this.handleThumbClick.bind(this);

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener("click", this.onThumbClick);
    });
  }

  handleThumbClick(evt) {
    const thumb = evt.target;

    const thumbIndex = parseInt(thumb.id.replace("product-thumb-", "")) - 1;

    const image = this.images[thumbIndex];

    this.currentThumbIndex = thumbIndex;
    this.changeActiveThumb();
    this.changeActiveImage();
  }

  changeActiveThumb() {
    this.thumbs.forEach((thumb, index) => {
      if (index === this.currentThumbIndex) {
        thumb.classList.add("active");
      } else {
        thumb.classList.remove("active");
      }
    });
  }

  changeActiveImage() {
    this.images.forEach((image, index) => {
      if (index === this.currentThumbIndex) {
        image.classList.add("active");
      } else {
        image.classList.remove("active");
      }

      //   const parent = newMedia.parentElement;
      // parent.prepend(newMedia);
      // window.setTimeout(() => { parent.scroll(0, 0) });
    });
  }
}

customElements.define("product-images", ProductImages);
